import axios from 'axios';

/**
 * HTTP Request helper
 *
 * @param {string} endpoint
 * @param {Object} formData
 * @param {Object} parameters
 * @returns {Promise}
 */
const request = (endpoint, formData = {}, parameters = {}) => {
    return new Promise((resolve, reject) => {
        const api = process.env.REACT_APP_API_URL.replace(/\/$/, '');
        const url = `${api}/${endpoint}`;
        const method = ('method' in parameters ? parameters['method'] : 'get');
        const timeout = ('timeout' in parameters ? parameters['timeout'] : 5000);
        const cancelToken = axios.CancelToken.source();
        const urlParams = new URLSearchParams();
        const requestData = (method === 'get' ? { params: urlParams } : { data: urlParams });
        const timer = setTimeout(() => cancelToken.cancel('Request timeout!'), timeout);

        Object.keys(formData).forEach((key) => {
            let formValue = (typeof (formData[key]) === "object" ? JSON.stringify(formData[key]) : formData[key]);
            urlParams.append(key, formValue);
        });

        parameters['cancelToken'] = cancelToken.token;

        axios({ ...parameters, ...requestData, url, method }).then(response => {
            const responseData = response.data;

            clearTimeout(timer);

            if (responseData.error?.message) {
                reject(responseData.error);
            }
            else {
                const returnData = responseData.success || '';
                resolve(returnData);
            }
        }).catch(reject);
    });
}

export default request;